module.exports = __webpack_public_path__ + "static/img/2.a9e4283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/resourcePool/2.png
// module id = w6aj
// module chunks = 2